module.exports = __webpack_public_path__ + "static/media/linkedin_sm.3d317e97ad611d0a4b52d07d26dc74b7.svg";